import { render, staticRenderFns } from "./AddCareer.vue?vue&type=template&id=b2e06dbe&scoped=true&"
import script from "./AddCareer.vue?vue&type=script&lang=js&"
export * from "./AddCareer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e06dbe",
  null
  
)

export default component.exports